import { useEffect, useRef, useState, useContext } from 'react';
// material
import { alpha } from '@mui/material/styles';
import { Box, MenuItem, ListItemIcon, ListItemText, IconButton, Typography } from '@mui/material';
// components
import MenuPopover from '../../components/MenuPopover';
import {  useTranslation } from 'react-i18next';
import LangContext from '../../components/common/LangContext';
// ----------------------------------------------------------------------

const LANGS = [
  {
    value: 'en',
    label: 'English',
    icon: '/static/icons/ic_flag_en.svg'
  },
  {
    value: 'de',
    label: 'German',
    icon: '/static/icons/ic_flag_de.svg'
  }
  // {
  //   value: 'fr',
  //   label: 'French',
  //   icon: '/static/icons/ic_flag_fr.svg'
  // }
];



// ----------------------------------------------------------------------

export default function LanguagePopover() {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  //const [selectedLang, setSelectedLang] = useState(null);
  
  const { setLang } = useContext(LangContext);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const {t, i18n} = useTranslation();

  const handleSelect = (option) => {
    console.log(option);
    setOpen(false);

    setTimeout(() => {

      i18n.changeLanguage(option.value);
      
      setLang(option.value);
    });
  };


  console.log(i18n);

  // useEffect( ( ) =>{
  //   if (i18n.isInitialized){
   
  //   }
   
  // }, [i18n] );
  var selectedLang = (LANGS.filter( p => p.value == i18n.language)[0]);

  console.log(selectedLang);
  if (selectedLang == null){
    selectedLang = LANGS[0];
  }

  return (
    <>

      {/* <Typography>{ t("key")}</Typography>
       */}
      <IconButton
        className="langButton"
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          padding: 0,
          width: 44,
          height: 44,
          ...(open && {
            bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.focusOpacity)
          })
        }}
      >
        {/* <img id={ selectedLang.value} src={ selectedLang.icon} alt={selectedLang.label} /> */}
        {selectedLang.value}
      </IconButton>

      <MenuPopover open={open} onClose={handleClose} anchorEl={anchorRef.current}>
        <Box sx={{ py: 1 }}>
          {LANGS.map((option) => (
            <MenuItem
              key={option.value}
              selected={option.value === selectedLang.value}
              onClick={ () => handleSelect(option) }
              sx={{ py: 1, px: 2.5 }}
            >
              {/* <ListItemIcon>
                <Box component="img" alt={option.label} src={option.icon} />
              </ListItemIcon> */}
              <ListItemText primaryTypographyProps={{ variant: 'body2' }}>
                {option.label}
              </ListItemText>
            </MenuItem>
          ))}
        </Box>
      </MenuPopover>
    </>
  );
}
